module.exports = __webpack_public_path__ + "img/icon-question-rating-radiobutton-active.d050fbd0.svg";